import { useEffect } from 'react';
import { isAndroid, isIOS } from 'react-device-detect';

function useMobileRedirecter() {
    useEffect(() => {
        const mobileWhiteListPages = ['/forms/', '/pages', '/userformdata/'];
        const promptPages = ['/meet/'];
        const path = window.location.pathname || '';
        if (mobileWhiteListPages.some((page) => path.startsWith(page))) {
            return;
        }
        if ((isAndroid || isIOS) && promptPages.some((page) => path.startsWith(page))) {
            showPrompt();
        } else if (isAndroid || isIOS) {
            if (isAndroid) {
                const url = 'intent://chat.optono.me/#Intent;scheme=Optonome;package=org.intelladapt.optonome;end';
                window.location.replace(url);
            } else if (isIOS) {
                window.location.replace('Optonome://');
                setTimeout(() => {
                    window.location.replace('https://apps.apple.com/us/app/optonome/id1523086139');
                }, 10000);
            }
        }
    }, []);

    const showPrompt = () => {
        const prompt = document.createElement('div');
        prompt.innerHTML = `
            <div style="position:fixed;bottom:20px;left:20px;right:20px;background:white;padding:12px;border-radius:8px;box-shadow:0 2px 10px rgba(0,0,0,0.2);z-index:9999;font-family:sans-serif;max-width:400px;margin:0 auto;">
                <div style="display:flex;justify-content:space-between;margin-bottom:10px;">
                    <span style="font-weight:bold;">Open in optonome app</span>
                    <button id="closePrompt" style="background:none;border:none;font-size:18px;cursor:pointer;">×</button>
                </div>
                <div style="display:flex;gap:8px;">
                    <button id="openApp" style="flex:1;padding:10px;background:#50aeb0;color:white;border:none;border-radius:6px;">Open</button>
                    <button id="stayBrowser" style="flex:1;padding:10px;background:#f0f0f0;border:none;border-radius:6px;">Stay</button>
                </div>
            </div>
        `;

        document.body.appendChild(prompt);

        document.getElementById('openApp')?.addEventListener('click', () => {
            if (isAndroid) {
                window.location.href =
                    'intent://chat.optono.me/#Intent;scheme=Optonome;package=org.intelladapt.optonome;end';
            } else if (isIOS) {
                window.location.href = 'Optonome://';
                setTimeout(() => {
                    window.location.replace('https://apps.apple.com/us/app/optonome/id1523086139');
                }, 10000);
            }
            prompt.remove();
        });

        document.getElementById('stayBrowser')?.addEventListener('click', () => {
            prompt.remove();
        });

        document.getElementById('closePrompt')?.addEventListener('click', () => {
            prompt.remove();
        });
    };

    return null;
}

export default useMobileRedirecter;
